import { assign, isEmpty, isFunction, isNil, isNumber, isObject, isString, map } from '@antv/util';
import { getTickMethod } from './tick-method/register';
var Scale = /** @class */ (function () {
    function Scale(cfg) {
        /**
         * åº¦éçç±»å
         */
        this.type = 'base';
        /**
         * æ¯å¦åç±»ç±»åçåº¦é
         */
        this.isCategory = false;
        /**
         * æ¯å¦çº¿æ§åº¦éï¼ælinear, time åº¦é
         */
        this.isLinear = false;
        /**
         * æ¯å¦è¿ç»­ç±»åçåº¦éï¼linear,time,log, pow, quantile, quantize é½æ¯æ
         */
        this.isContinuous = false;
        /**
         * æ¯å¦æ¯å¸¸éçåº¦éï¼ä¼ å¥åä¼ åºä¸è´
         */
        this.isIdentity = false;
        this.values = [];
        this.range = [0, 1];
        this.ticks = [];
        this.__cfg__ = cfg;
        this.initCfg();
        this.init();
    }
    // å¯¹äºåå§å¼çå¿è¦è½¬æ¢ï¼å¦åç±»ãæ¶é´å­æ®µéè½¬æ¢ææ°å¼ï¼ç¨transform/mapå½åå¯è½æ´å¥½
    Scale.prototype.translate = function (v) {
        return v;
    };
    /** éæ°åå§å */
    Scale.prototype.change = function (cfg) {
        // è¦çéç½®é¡¹ï¼èä¸æ¿ä»£
        assign(this.__cfg__, cfg);
        this.init();
    };
    Scale.prototype.clone = function () {
        return this.constructor(this.__cfg__);
    };
    /** è·ååæ è½´éè¦çticks */
    Scale.prototype.getTicks = function () {
        var _this = this;
        return map(this.ticks, function (tick, idx) {
            if (isObject(tick)) {
                // ä»å½ç¬¦åTickç±»åæ¶æææä¹
                return tick;
            }
            return {
                text: _this.getText(tick, idx),
                tickValue: tick,
                value: _this.scale(tick), // scaled
            };
        });
    };
    /** è·åTickçæ ¼å¼åç»æ */
    Scale.prototype.getText = function (value, key) {
        var formatter = this.formatter;
        var res = formatter ? formatter(value, key) : value;
        if (isNil(res) || !isFunction(res.toString)) {
            return '';
        }
        return res.toString();
    };
    // è·åéç½®é¡¹ä¸­çå¼ï¼å½å scale ä¸çå¼å¯è½ä¼è¢«ä¿®æ¹
    Scale.prototype.getConfig = function (key) {
        return this.__cfg__[key];
    };
    // scaleåå§å
    Scale.prototype.init = function () {
        assign(this, this.__cfg__);
        this.setDomain();
        if (isEmpty(this.getConfig('ticks'))) {
            this.ticks = this.calculateTicks();
        }
    };
    // å­ç±»ä¸è¦çæäºå±æ§ï¼ä¸è½ç´æ¥å¨ç±»ä¸å£°æï¼å¦åä¼è¢«è¦ç
    Scale.prototype.initCfg = function () { };
    Scale.prototype.setDomain = function () { };
    Scale.prototype.calculateTicks = function () {
        var tickMethod = this.tickMethod;
        var ticks = [];
        if (isString(tickMethod)) {
            var method = getTickMethod(tickMethod);
            if (!method) {
                throw new Error('There is no method to to calculate ticks!');
            }
            ticks = method(this);
        }
        else if (isFunction(tickMethod)) {
            ticks = tickMethod(this);
        }
        return ticks;
    };
    // range çæå°å¼
    Scale.prototype.rangeMin = function () {
        return this.range[0];
    };
    // range çæå¤§å¼
    Scale.prototype.rangeMax = function () {
        return this.range[1];
    };
    /** å®ä¹åè½¬ 0~1 */
    Scale.prototype.calcPercent = function (value, min, max) {
        if (isNumber(value)) {
            return (value - min) / (max - min);
        }
        return NaN;
    };
    /** 0~1è½¬å®ä¹å */
    Scale.prototype.calcValue = function (percent, min, max) {
        return min + percent * (max - min);
    };
    return Scale;
}());
export default Scale;
//# sourceMappingURL=base.js.map